import React from 'react'
import PropTypes from 'prop-types'
import DateTimePicker from 'react-datepicker'
import DatePicker from 'react-datepicker'
import './CommonDateTimePicker.scss'

const CalendarIconInput = React.forwardRef(({ value, onClick, onChange, placeholder, className, onBlur }, ref) => (
  <div className="custom-datepicker-input-wrapper" onClick={onClick}>
    <input
      ref={ref}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      className={className || 'form-control'}
      readOnly
    />
    <svg className="custom-datepicker-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
  </div>
));

const CommonDateTimePicker = ({
  selected,
  onChange,
  showTimeSelect,
  className,
  dateFormat,
  timeIntervals,
  placeholderText,
  minDate,
  maxDate,
  timeFormat,
  showTimeSelectOnly,
  disabled,
  dateRange,
  isClearable,
  startDate,
  endDate,
  minTime,
  maxTime,
  isDateEnabled,
  popperClassName,
  popperPlacement,
  positionFixed,
  onBlur,
  inputClassName
}) => {
  return (
    <div className={className}>
      {!dateRange ? (
        <DateTimePicker
          selected={
            selected instanceof Date && !isNaN(selected) ? selected : null
          }
          onChange={onChange}
          showTimeSelect={showTimeSelect}
          dateFormat={dateFormat}
          timeIntervals={timeIntervals}
          placeholderText={placeholderText}
          minDate={minDate}
          maxDate={maxDate}
          timeFormat={timeFormat}
          showTimeSelectOnly={showTimeSelectOnly}
          disabled={disabled}
          isClearable={isClearable}
          minTime={minTime}
          maxTime={maxTime}
          showMonthDropdown
          showYearDropdown
          dropdownMode='select'
          popperClassName={popperClassName}
          popperPlacement={popperPlacement}
          positionFixed={positionFixed}
          customInput={<input className={inputClassName || 'form-control'} />}
        />
      ) : (
        <DatePicker
          selected={
            selected instanceof Date && !isNaN(selected) ? selected : null
          }
          onChange={onChange}
          startDate={startDate}
          endDate={endDate}
          minDate={minDate}
          maxDate={maxDate}
          selectsRange
          isClearable={isClearable}
          placeholderText={placeholderText}
          dateFormat={dateFormat}
          filterDate={isDateEnabled}
          popperClassName={popperClassName}
          popperPlacement={popperPlacement}
          positionFixed={positionFixed}
          onBlur={onBlur}
          customInput={<CalendarIconInput placeholder={placeholderText} className={inputClassName || 'form-control'} />}
        />
      )}
    </div>
  )
}

CommonDateTimePicker.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}

CommonDateTimePicker.defaultProps = {
  className: '',
  selected: null,
  dateFormat: 'dd-MM-yyyy',
  timeIntervals: 15,
  placeholderText: 'Select date and time',
  minDate: new Date(),
  maxDate: '',
  className: 'custom-datepicker',
  showTimeSelect: true,
  timeFormat: 'h:mm aa',
  showTimeSelectOnly: false,
  disabled: false,
  selectsRange: true,
  dateRange: false,
  isClearable: false,
  startDate: null,
  endDate: null,
  maxTime: '',
  minTime: '',
  isDateEnabled: '',
  popperClassName: '',
  popperPlacement: '',
  positionFixed: false,
  onBlur: () => {},
  inputClassName: 'form-control'
}

export default CommonDateTimePicker
